export const SHOW_LOADING = 'SHOW_LOADING';
export const GET_CAMPAIGN = 'GET_CAMPAIGN';
export const LOAD_CAMPAIGN = 'LOAD_CAMPAIGN';
export const UPDATE_CAMPAIGN = 'UPDATE_CAMPAIGN';
export const CREATE_CAMPAIGN = 'CREATE_CAMPAIGN';
export const GET_CAMPAIGN_TEMPLATE_TYPES = 'GET_CAMPAIGN_TEMPLATE_TYPES';
export const LOAD_CAMPAIGN_TEMPLATE_TYPES = 'LOAD_CAMPAIGN_TEMPLATE_TYPES';
export const GET_WHATSAPP_NUMBERS = 'GET_WHATSAPP_NUMBERS';
export const SAVE_WHATSAPP_NUMBERS = 'SAVE_WHATSAPP_NUMBERS';
export const RESET_CAMPAIGN='RESET_CAMPAIGN'